import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { DASHBOARD_TABS } from "@/constants/dashboardTabs";
import { ROUTES } from "@/routes/routes.config";

const tabPathToIdMap: Record<string, string> = {
  notifications: DASHBOARD_TABS.NOTIFICATION,
  orderHistory: DASHBOARD_TABS.ORDER,
  myVideos: DASHBOARD_TABS.MY_VIDEO,
  updateProfile: DASHBOARD_TABS.UPDATE,
  testimonials: DASHBOARD_TABS.TESTIMONIAL,
  requestANurse: DASHBOARD_TABS.REQUEST_A_NURSE,
  consultations: DASHBOARD_TABS.CONSULTATIONS
};

const tabIdToPathMap = Object.entries(tabPathToIdMap).reduce(
  (acc, [path, id]) => {
    acc[id] = path;
    return acc;
  },
  {} as Record<string, string>
);

export const useDashboardTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const currentPathSegment = location.pathname.split("/")[2];  

  const initialTabId = useMemo(() => {
    return tabPathToIdMap[currentPathSegment] || DASHBOARD_TABS.NOTIFICATION;
  }, [currentPathSegment]);

  const [activeTabId, setActiveTabId] = useState(initialTabId);
 
  useEffect(() => {
    const newTabId = tabPathToIdMap[currentPathSegment];
    if (newTabId && newTabId !== activeTabId) {
      setActiveTabId(newTabId);
    }
  }, [currentPathSegment, activeTabId]);

  const handleTabChange = (newTabId: string) => {
    setActiveTabId(newTabId);

    const path = tabIdToPathMap[newTabId];
    if (path) {
      navigate(`${ROUTES.DASHBOARD}/${path}`);
    }
  };

  return {
    activeTabId,
    handleTabChange,
  };
};
